import React from 'react';

import { isErrorLog } from '../utils';

interface LogsDisplayProps {
  logs: string[];
}

const LogsDisplay: React.FC<LogsDisplayProps> = ({ logs }) => {
  const logsCount = logs.length;
  const isEmpty = logsCount === 0;
  const emptyMessage = 'No logs to display';
  const countMessage = `${logsCount} log entries`;

  const logEntries = logs.map((entry, index) => {
    const isError = isErrorLog(entry);
    const logColorClass = isError ? 'text-red-400' : 'text-green-500';

    return (
      <div className="inline-flex flex-in gap-1" key={index}>
        <span>[{index}]</span>
        <span className={logColorClass}>{entry}</span>
      </div>
    );
  });

  const codeClassName = [
    'flex flex-col gap-2',
    'bg-gray-900 dark:bg-black',
    'px-4 py-3 rounded-md',
    'outline outline-1 outline-black dark:outline-gray-700',
    'h-80 overflow-y-auto',
    'font-[monospace] text-gray-500 text-xs',
  ].join(' ');

  return (
    <div className="flex flex-col gap-4">
      <code className={codeClassName}>
        {isEmpty ? <span>{emptyMessage}</span> : logEntries}
      </code>

      <span className="text-gray-600 dark:text-gray-400 paragraph-3">{countMessage}</span>
    </div>
  );
};

export default LogsDisplay;
